import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  @Input() formParameter;
  @Input() buttonText;

  constructor() { }

  ngOnInit() {
    //console.log(this.formParameter.invalid);
  }



}
